import { Tooltip } from "antd";
import _ from "lodash";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAccessTokenDataPools, getSessionMetadata } from "redux/actions";

const sessionSelector = (state) => {
    const routeID = _.get(state, ["playlist", "data", "routeID"]);
    if (!routeID) return undefined;

    return _.get(state, ["sessions", routeID]);
};
const streamOffsetsSelector = (state) => state.playlist.data.offsets;
const dataPoolsSelector = (state) => state.dataPools;
const sessionMetadataSelector = (state) => state.playlist.metadata;

const SessionInfoTab = () => {
    const dispatch = useDispatch();
    const session = useSelector(sessionSelector);
    const streamOffsets = useSelector(streamOffsetsSelector);
    const dataPools = useSelector(dataPoolsSelector);
    const sessionMetadata = useSelector(sessionMetadataSelector);

    useEffect(() => {
        if (_.isEmpty(dataPools)) {
            dispatch(getAccessTokenDataPools());
        }
    }, [dispatch, dataPools]);

    useEffect(() => {
        if (_.isEmpty(sessionMetadata)) {
            dispatch(getSessionMetadata());
        }
    }, [dispatch, sessionMetadata]);

    const sessionStreamInfo = session?.stream_info || [];
    const sessionDataPoolID = session?.data_pool || null;

    const sessionDataPool = useMemo(() => {
        if (!sessionDataPoolID) {
            return "Unknown";
        }

        const dpIndex = _.findIndex(dataPools, { id: sessionDataPoolID });
        const dataPoolName = _.get(dataPools, [dpIndex, "name"], "Unknown");
        return dataPoolName;
    }, [dataPools, sessionDataPoolID]);

    const combinedStreamInfo = useMemo(
        () =>
            sessionStreamInfo.map((stream, idx) => ({
                ...stream,
                offset: streamOffsets?.[idx],
            })),
        [sessionStreamInfo, streamOffsets],
    );

    return (
        <div className="SessionInfoTabMain">
            <div>
                <strong>Session's Data Pool:</strong> {sessionDataPool} (ID: {sessionDataPoolID})
            </div>
            <div>
                <strong>Reason for upload:</strong> {sessionMetadata?.reason_for_upload || "Unknown"}
            </div>
            <div className="SessionInfoTabMainTitle">Available Session Streams:</div>
            <div className="SessionInfoTabMainStreamsList">
                {_.map(combinedStreamInfo, (streamInfo, idx) => {
                    return (
                        <div
                            className="SessionInfoTabStreamInfoMain"
                            key={idx}>
                            <div className="SessionInfoTabStreamInfoMainTopRow">
                                <div className="SessionInfoTabStreamInfoMainItem">
                                    <div className="SessionInfoTabStreamInfoMainItemValue">
                                        <span style={{ fontWeight: "bold" }}>{_.get(streamInfo, "type", "unknown")}</span> (
                                        {_.get(streamInfo, "label", "unknown")})
                                    </div>
                                </div>
                                <div className="SessionInfoTabStreamInfoMainRightSide">
                                    <div>
                                        Stream Index: <strong>{_.get(streamInfo, "stream_index", "unknown")}</strong>
                                    </div>
                                    <Tooltip
                                        title={_.get(streamInfo, "archived", false) ? "Stream has been archived" : "Stream is visible (NOT archived)"}
                                        placement="topLeft">
                                        <div className={`SessionInfoTabStreamInfoMainStatus ${_.get(streamInfo, "archived", false) ? "Archived" : ""}`}>
                                            {_.get(streamInfo, "archived", false) ? "Archived" : "Visible"}
                                        </div>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="SessionInfoTabStreamInfoMainItem">
                                <div className="SessionInfoTabStreamInfoMainItemLabel">Offset:</div>
                                <div className="SessionInfoTabStreamInfoMainItemValue">{_.get(streamInfo, "offset", "unknown")}m</div>
                            </div>
                            <div className="SessionInfoTabStreamInfoMainItem">
                                <div className="SessionInfoTabStreamInfoMainItemLabel">Source Index:</div>
                                <div className="SessionInfoTabStreamInfoMainItemValue">{_.get(streamInfo, "source", "unknown")}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SessionInfoTab;
